import { createFileRoute, redirect } from '@tanstack/react-router'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import {
  getNoWorkspacesEntryRoute,
  shouldRedirectToNoWorkspaceEntry,
} from '@/features/bootstrap/domain/bootstrap-entry'
import {
  getBootstrapWorkspace,
  getPreferredBootstrapWorkspaceId,
  getWorkspaceEntryRoute,
  hasBootstrapWorkspaceId,
} from '@/features/bootstrap/domain/bootstrap-workspaces'
import WorkspaceHomePage from '@/pages/workspace/workspace-home'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import {
  getLastWorkspaceId,
  setLastWorkspaceId,
} from '@/shared/lib/last-workspace'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectWorkspaceToGtm } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute('/$lang/workspace/$workspaceId/')({
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      await redirectWorkspaceToGtm(context, params)
    }
    requireAuthenticated(context, params)
    setLastWorkspaceId(params.workspaceId)

    const bootstrap = await context.queryClient.ensureQueryData(
      bootstrapQueryOptions(),
    )
    if (shouldRedirectToNoWorkspaceEntry(bootstrap)) {
      throw redirect({
        to: getNoWorkspacesEntryRoute(bootstrap),
        params: { lang: params.lang },
        replace: true,
      })
    }

    if (!hasBootstrapWorkspaceId(bootstrap.workspaces, params.workspaceId)) {
      const preferredWorkspaceId = getPreferredBootstrapWorkspaceId(
        bootstrap.workspaces,
        getLastWorkspaceId(),
      )

      if (preferredWorkspaceId) {
        const preferredWorkspace = getBootstrapWorkspace(
          bootstrap.workspaces,
          preferredWorkspaceId,
        )
        throw redirect({
          to: preferredWorkspace
            ? getWorkspaceEntryRoute(preferredWorkspace)
            : '/$lang/workspace/$workspaceId',
          params: { lang: params.lang, workspaceId: preferredWorkspaceId },
          replace: true,
        })
      }
    }

    // No GTM redirect here: entry points (/app, workspace switch, onboarding)
    // already land GTM workspaces on GTM via getWorkspaceEntryRoute, and this
    // route is the workspace's "New chat" screen.
  },
  component: WorkspaceHomePage,
  staticData: { layout: 'main' },
})
